// extracted by mini-css-extract-plugin
export default {"link":"link_link__PhOtQ","text":"link_text__3UpB7","icon":"link_icon__AW0fJ"};